import { render, staticRenderFns } from "./Odds.vue?vue&type=template&id=bd4fb060&scoped=true&"
import script from "./Odds.vue?vue&type=script&lang=js&"
export * from "./Odds.vue?vue&type=script&lang=js&"
import style0 from "./Odds.vue?vue&type=style&index=0&id=bd4fb060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4fb060",
  null
  
)

export default component.exports